import gql from 'graphql-tag';
import { COMPAIGN_FRAGMENT, MINIMAL_COMPAIGN_FRAGMENT } from './fragment';

export const GET_COMPAIGNS = gql`
  query Compaigns($input: CompaignsInput) {
    compaigns(input: $input) {
      totalCount
      compaigns {
        ...MinimalCompaignFragment
      }
    }
  }
  ${MINIMAL_COMPAIGN_FRAGMENT}
`;

export const GET_COMPAIGN = gql`
  query Compaign($input: CompaignInput) {
    compaign(input: $input) {
      ...CompaignFragment
    }
  }
  ${COMPAIGN_FRAGMENT}
`;
